export default "__VITE_ASSET__084ffc7e__"